module.exports = __webpack_public_path__ + "img/2.3e5a03ab.jpg";